var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:['loader', ..._vm.variantClassList],style:({ zIndex: _vm.zIndex }),attrs:{"data-testid":"loader"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader__animation"},[_c('div',{staticClass:"loader__piece"}),_c('div',{staticClass:"loader__piece"}),_c('div',{staticClass:"loader__piece"}),_c('div',{staticClass:"loader__piece"})])
}]

export { render, staticRenderFns }